import React, { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import useAnalytics from 'lib/analytics/useAnalytics'
import { EVENT_TEST_DRIVE_UPLOADED } from 'lib/analytics/events'
import { PROPERTY_LOCATION_ON_PAGE } from '@anvilco-pkg/customer-data/segment/eventProperties'
import { SectionContext } from 'components/page/Section'

import EmbedForm from 'components/EmbedForm'

import { APP_URL } from 'helpers'

const HEIGHT = 500

const getTestDriveUrl = ({ mode }) =>
  `${APP_URL}/embed/test-drive/${mode}/upload`

const StyledEmbedForm = styled(EmbedForm).withConfig({
  shouldForwardProp: (prop) => ['castUploaded'].indexOf(prop) === -1,
})`
  && {
    height: 100%;
    width: ${({ inTopBanner }) => (inTopBanner ? '450px' : '100%')};
    height: 314px;
    display: block;
  }
`

export default function TestDriveUploader ({ mode, inTopBanner, ...others }) {
  let sectionName

  if (SectionContext) {
    const { name } = useContext(SectionContext)
    sectionName = name
  }

  const [castEid, setCastEid] = useState(null)
  const testDriveUploadedEventHandler = useAnalytics({
    eventName: EVENT_TEST_DRIVE_UPLOADED,
  })

  const handlePDFUploaded = () => {
    testDriveUploadedEventHandler({
      mode,
      [PROPERTY_LOCATION_ON_PAGE]: inTopBanner ? 'top-banner' : sectionName,
    })
  }

  const handleMessage = (event) => {
    if (event.origin !== APP_URL) return

    if (event.data?.castEid) {
      setCastEid(event.data.castEid)
      window.open(
        `/test-drive/${mode}/?castEid=${event.data?.castEid}`,
        '_blank'
      )
    }
  }

  useEffect(() => {
    addEventListener('message', handleMessage)

    return () => {
      removeEventListener('message', handleMessage)
    }
  }, [])

  return (
    <StyledEmbedForm
      {...others}
      src={getTestDriveUrl({ mode })}
      castUploaded={castEid}
      inTopBanner={inTopBanner}
      onFormSubmitted={handlePDFUploaded}
      style={{ height: `${HEIGHT}px` }}
    />
  )
}

TestDriveUploader.propTypes = {
  mode: PropTypes.oneOf(['pdf-templates', 'etch']),
}
